import type { AppBarVariant } from "~/components/app-bar/helpers";
import { PageType } from "~/lib/router/enums";

export const pathname = "/article";

export const page = {
  route(
    query: QueryParameters<{
      appBarVariant?: AppBarVariant;
      commentID?: string;
      entityId: string;
      entityUuid: string;
    }>,
  ) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Article },
    };
  },
};
